import { Component, OnInit } from '@angular/core';
import { displayResponse } from 'src/app/models/response';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DisplayNotificationService } from '../services/common/notification.service';

@Component({
  selector: 'app-notification-loading',
  providers: [NotificationService],
  template: `
  <div id="overlay-loader" *ngIf="displayLoading">
    <div class="k-icon k-i-loading outer"></div>
  </div>
  `,
  styles: [`
    .k-i-loading.outer {
      position: fixed;
      font-size: 69px;
      background-color: transparent;
      color: #dba001 !important;
      z-index: 3 !important;
      top: 43%;
      left: 50%;
    }

    #overlay-loader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.06);
      text-align: -webkit-center;
      text-align: -moz-center;
  }
`]
})
export class NotificationLoadingComponent implements OnInit {

  constructor(private notificationService: DisplayNotificationService) { }
  displayLoading = true;

  ngOnInit() {
    this.notificationService.getLoadStatus$.subscribe(load => {
      this.displayLoading = load.status || false;
    });
  }
}
